import React from 'react'

interface AppRefreshIconProps {
  color?: string
  className?: string
}

export const AppRefreshIcon: React.FC<AppRefreshIconProps> = ({ color = '#5E5E5E', className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Top curved arrow */}
      <path
        d="M13.6569 5.65685C12.5327 3.59797 10.4183 2.25 8 2.25C4.82436 2.25 2.25 4.82436 2.25 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 5.5L14 5.5L14 2.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Bottom curved arrow */}
      <path
        d="M2.34315 10.3431C3.46734 12.402 5.58172 13.75 8 13.75C11.1756 13.75 13.75 11.1756 13.75 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5 10.5L2 10.5L2 13.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
